<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        version: VERSION,
        description: DESCRIPTION
      }
    },

    components: {
    },

    methods: {
    },

    computed: {
      ...mapGetters(['isUserLoggedIn'])
    },

    watch: {
      isUserLoggedIn (newS) {
        if (!newS) {
          this.$router.push({name: 'auth'})
        }
      }
    }
  }
</script>
